import { 
  navMenus as enNavMenus,
  rootConfig as enRootConfig,
} from './en-US/index'
// import { 
//   navMenus as zhNavMenus,
//   rootConfig as zhRootConfig,
//  } from './zh-hans/index'
import { 
  navMenus as twNavMenus,
  rootConfig as twRootConfig,
 } from './zh-tw/index'

import { LANG_KEY } from '../utils'

const defaultNavMenus = enNavMenus
const defaulRootConfig = enRootConfig

const navMenusMap = {
  [LANG_KEY.en]: enNavMenus,
  // [LANG_KEY.zh]: zhNavMenus,
  [LANG_KEY.tw]: twNavMenus,
}

const rootConfigMap = {
  [LANG_KEY.en]: enRootConfig,
  // [LANG_KEY.zh]: zhRootConfig,
  [LANG_KEY.tw]: twRootConfig,
}

export const getNavMenusByLang = (lang) => {
  return navMenusMap[lang] || defaultNavMenus
}

export const getRootConfigByLang = (lang) => {
  return rootConfigMap[lang] || defaulRootConfig
}




// WEBPACK FOOTER //
// ./src/config/index.js